<template>
  <router-link :to="location">
    участник скачек
  </router-link>
</template>

<script>
export default {
  name: 'DerbyPlayerLink',

  props: {
    derbyPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {Object} */
    location() {
      const id = this.derbyPlayerId;

      const loc = {
        name: 'derby_player',
        params: {
          derbyId:  id.derbyId,
          playerId: id.playerId,
        }
      };

      return loc;
    },
  }
};
</script>
